import React, { useEffect, useState } from "react";
import {
  Table,
  Card,
  Typography,
  Button,
  Select,
  notification,
  Upload,
  Tag,
  Input,
  Modal,
  DatePicker,
} from "antd";
// import { MdConnectWithoutContact } from "react-icons/md";
import { postReq } from "../api";
import { toastNotification } from "../utils/toasthelper";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import {
  DownloadOutlined,
  LinkedinOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import AddOutreachModal from "../components/addOutreachModel";
import { useHistory } from "react-router-dom";
import CreateSpocModal from "../components/addSpocModel";
import moment from "moment";
const { Title, Text } = Typography;
const { RangePicker } = DatePicker;

const SPOC = () => {
  const location = useLocation();
  const { record } = location.state || {};
  const history = useHistory();
  const [data, setData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedSpoc, setSelectedSpoc] = useState(null);
  const [openSpocModal, setOpenSpocModal] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  const statusColorMap = {
    Pending: "orange",
    IN_DISCUSSION: "green",
    REPLIED: "blue",
    NOT_INTERESTED: "red",
    NO_REPLY: "gold",
  };

  const columns2 = [
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <div>
          <Button
            type="link"
            disabled={record.status == "NOT_CONNECTED"}
            onClick={(e) => {
              e.stopPropagation();
              history.push(`/company/spoc`, { record });
            }}
          >
            View
          </Button>
          <Button
            type="link"
            // disabled={record.status == "NOT_CONNECTED"}
            onClick={(e) => {
              // if (record.name) {
              //   toastNotification(
              //     "error",
              //     "This Edit is Not posible please contact developer",
              //   );
              //   return;
              // }
              setSelectedSpoc(record);
              setIsEdit(true);
            }}
          >
            Edit
          </Button>
        </div>
      ),
    },
    {
      title: "Name",
      key: "name",
      render: (_, record) => (
        <>
          <Text>{record.name || `${record.firstName} ${record.lastName}`}</Text>
          <p>{record.region || null}</p>
        </>
      ),
    },
    {
      title: "Mobile",
      dataIndex: "phone",
      key: "phone",
      render: (text) => <p>{text || "-"}</p>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text) => (
        <a
          //   href={`mailto:${text}`}
          href={`https://outlook.office.com/mail/deeplink/compose?to=${text}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#3699FF", textDecoration: "underline" }}
        >
          {text}
        </a>
      ),
    },
    {
      title: "Designation",
      dataIndex: "designation",
      key: "designation",
    },
    {
      title: "Linked In",
      dataIndex: "linkedinUrl",
      key: "linkedinUrl",
      render: (text) => (
        <a
          //   href={`mailto:${text}`}
          href={`${text}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#3699FF", textDecoration: "underline" }}
        >
          <LinkedinOutlined style={{ fontSize: 16 }} />
        </a>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => <Tag color={statusColorMap[text]}>{text}</Tag>,
    },
    {
      title: "Outreach",
      key: "outreach",
      render: (_, record) => (
        <Button
          type="secondary"
          onClick={() => {
            setOpenModal(true);
            setSelectedSpoc(record._id);
          }}
          style={{
            height: "16px",
            padding: "12px 5px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          disabled={record.status !== "NOT_CONNECTED"}
        >
          <PlusOutlined style={{ fontSize: 14, marginLeft: "5px" }} />
        </Button>
      ),
    },
  ];
  const [loading, setLoading] = useState(false);

  const [fileList, setFileList] = useState(null);
  const [tableParams, setTableParams] = useState({
    page: 1,
    limit: 20,
    search: "",
  });
  const [total, setTotal] = useState(0);
  const [downloading, setDownloading] = useState(false);
  const [stats, setStats] = useState({
    totalCompanies: 0,
    companiesWithSpoc: 0,
    totalSpocs: 0,
  });
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  const [dateRange, setDateRange] = useState([]);
  const fetchStat = async () => {
    try {
      const result = await postReq("common/spocStats", {});
      if (result.status == 1) {
        setStats(result.data);
      } else {
        setStats(null);
      }
    } catch (error) {}
  };
  useEffect(() => {
    fetchStat();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    setSelectedSpoc(null);
    try {
      let results;
      results = await postReq(`common/spoc`, { ...tableParams });
      if (results.status === 1) {
        setData(results?.data);
        setTotal(results.meta.total);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      toastNotification("error", error.message);
      setLoading(false);
    }
  };
  useEffect(() => {
    const timeout = setTimeout(() => {
      fetchData();
    }, 300);

    return () => clearTimeout(timeout);
  }, [tableParams.search, tableParams.page, tableParams.limit]);

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams((prev) => ({
      ...prev,
      page: pagination.current,
      limit: pagination.pageSize,
    }));

    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  const handleOnChange = (e) => {
    setTableParams((prev) => ({ ...prev, search: e.target.value }));
  };

  const handleUploadExcel = async (file) => {
    const formData = new FormData();
    formData.append("excel", file);
    const res = await postReq("common/upload_spoc_bulk", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (res.status == 1) {
      notification.success({
        message: "Success",
        description: `successful.`,
        placement: "topRight",
      });
    } else {
      notification.success({
        message: "Error",
        description: `error.`,
        placement: "topRight",
      });
    }
  };

  const handleMultiDownload = async () => {
    if (!dateRange || dateRange.length !== 2) {
      toastNotification("error", "Please select start and end date");
      return;
    }

    try {
      setDownloading(true);

      const payload = {
        startDate: dateRange[0].startOf("day").toISOString(),
        endDate: dateRange[1].endOf("day").toISOString(),
      };

      const res = await postReq("/common/download_spocs", payload, {
        responseType: "blob",
      });

      const blob = new Blob([res], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Selected_Companies.xlsx";
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);

      toastNotification(
        "success",
        "Selected records downloaded successfully ✅",
      );

      setDownloadModalOpen(false);
    } catch (error) {
      console.error(error);
      toastNotification("error", "Download failed ❌");
    } finally {
      setDownloading(false);
    }
  };

  // const handleMultiDownload = async () => {
  //   try {
  //     setDownloading(true);
  //     const res = await postReq(
  //       "/common/download_spocs",
  //       {},
  //       // { jobIds: selectedRowKeys },
  //       { responseType: "blob" }, // IMPORTANT
  //     );

  //     // Create download
  //     const blob = new Blob([res], {
  //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });

  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = "Selected_Companies.xlsx";
  //     document.body.appendChild(a);
  //     a.click();

  //     a.remove();
  //     window.URL.revokeObjectURL(url);

  //     toastNotification(
  //       "success",
  //       "Selected records downloaded successfully ✅",
  //     );
  //   } catch (error) {
  //     console.error(error);
  //     toastNotification("error", "Download failed ❌");
  //   } finally {
  //     setDownloading(false);
  //   }
  // };

  return (
    <>
      <Card
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px",
              borderRadius: "20px 20px 0px 0px",
              margin: "0px -24px",
            }}
          >
            <div>
              <Title
                level={4}
                style={{
                  marginBottom: 0,
                  fontSize: "20px",
                  fontWeight: "800",
                  color: "#13487D",
                }}
              >
                SPOCS
              </Title>
            </div>

            <div style={{ display: "inline-flex", gap: "8px" }}>
              <Button
                type="secondary"
                icon={<DownloadOutlined />}
                onClick={() => {
                  setDownloadModalOpen(true);
                }}
                loading={downloading}
              >
                Download Spoc
              </Button>
              <Upload
                accept=".csv,.xls,.xlsx"
                fileList={fileList}
                maxCount={1}
                beforeUpload={() => false} // prevent auto upload
                onChange={(info) => {
                  const newFileList = info.fileList.slice(-1);
                  setFileList(newFileList);

                  const file = newFileList[0]?.originFileObj;
                  if (file) {
                    handleUploadExcel(file);
                  }
                }}
                disabled={downloading}
              >
                <Button icon={<UploadOutlined />}>Upload SPOC</Button>
              </Upload>
              <Button
                type="secondary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setOpenSpocModal(true);
                }}
                loading={downloading}
              >
                Add Spoc
              </Button>
              <Input
                placeholder="Search By Any Field"
                bordered={false}
                onChange={handleOnChange}
              />
            </div>
          </div>
        }
        style={{
          paddingLeft: "16px",
          color: "#13487D",
          borderRadius: "18px",
          maxWidth: "100%",
          overflow: "hidden",
        }}
        bordered={false}
      >
        <div style={{ display: "flex", gap: 20, marginBottom: "10px" }}>
          <Card style={{ minWidth: 180 }}>
            <Text type="secondary">Total SPOC</Text>
            <Title level={5} style={{ margin: 0 }}>
              {stats.totalSpocs}
            </Title>
          </Card>
          <Card style={{ minWidth: 180 }}>
            <Text type="secondary">Account with spoc</Text>
            <Title level={5} style={{ margin: 0 }}>
              {stats.companiesWithSpoc}
            </Title>
          </Card>
          <Card style={{ minWidth: 180 }}>
            <Text type="secondary">Total Account</Text>
            <Title level={5} style={{ margin: 0 }}>
              {stats.totalCompanies}
            </Title>
          </Card>
        </div>
        <Table
          rowKey="_id"
          columns={columns2}
          dataSource={data}
          pagination={{
            current: tableParams.page,
            pageSize: tableParams.limit,
            total,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 30],
            itemRender: (current, type, originalElement) => {
              if (type === "prev") return <a>Prev</a>;
              if (type === "next") return <a>Next</a>;
              return originalElement;
            },
            showTotal: (total, range) => (
              <span style={{ color: "#6b7280" }}>
                Showing {range[0]}–{range[1]} of {total}
              </span>
            ),
          }}
          loading={loading}
          scroll={{ x: "max-content" }}
          onChange={handleTableChange}
        />
      </Card>
      <AddOutreachModal
        open={openModal}
        spocId={selectedSpoc}
        onClose={() => setOpenModal(false)}
        onSuccess={fetchData}
      />
      <CreateSpocModal
        open={openSpocModal}
        onClose={() => setOpenSpocModal(false)}
        companyId={record?._id || null}
        onSuccess={fetchData}
      />
      <CreateSpocModal
        open={isEdit}
        onClose={() => {
          setSelectedSpoc(null);
          setIsEdit(false);
        }}
        companyId={record?._id || null}
        isEdit={isEdit}
        initialValues={selectedSpoc}
        onSuccess={fetchData}
      />
      <Modal
        title="Download SPOC"
        open={downloadModalOpen}
        onCancel={() => setDownloadModalOpen(false)}
        onOk={() => handleMultiDownload()}
        okText="Download"
        confirmLoading={downloading}
      >
        <RangePicker
          style={{ width: "100%" }}
          onChange={(dates) => setDateRange(dates)}
          disabledDate={(current) => current && current > moment().endOf("day")}
        />
      </Modal>
    </>
  );
};

export default SPOC;
